import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './app/router';
import './App.css';
import Header from './components/header';
import Footer from './components/footer';
import ContactForm from './components/contact-form';    
import Services from './components/services';
import Stats from './components/stats';

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
